// src/features/Analytics/hooks/useAnomalyDetection.js
import { useState, useEffect, useCallback } from 'react';
import { MLAnomalyDetector } from '../mlAnomalyDetector';
import { getData } from '../../../services/storageService';
import { useI18n } from '../../../i18n/i18n';

export const useAnomalyDetection = () => {
  const [detector] = useState(() => new MLAnomalyDetector());
  const [anomalyReport, setAnomalyReport] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const { t } = useI18n(); // Додаємо переклади

  const analyzeData = useCallback(async () => {
    setIsLoading(true);
    setError(null);

    try {
      const records = await getData('lainsa_records');
      if (!Array.isArray(records) || records.length === 0) {
        throw new Error(t('common_loadError'));
      }

      const report = detector.analyzeData(records, t); // Передаємо t
      setAnomalyReport(report);
      
      return report;
    } catch (err) {
      console.error('Anomaly detection error:', err);
      setError(err.message);
      return null;
    } finally {
      setIsLoading(false);
    }
  }, [detector, t]);

  // Перевірка нового запису
  const checkNewRecord = useCallback((record) => {
    return detector.checkNewRecord(record);
  }, [detector]);

  // Автоматичний аналіз при завантаженні
  useEffect(() => {
    analyzeData();
  }, [analyzeData]);

  return {
    anomalyReport,
    isLoading,
    error,
    analyzeData,
    checkNewRecord,
    hasAnomalies: anomalyReport ? anomalyReport.totalAnomalies > 0 : false,
    criticalAnomalies: anomalyReport ? anomalyReport.criticalCount : 0
  };
};


